import { useEffect, useState } from "react";
import { Grid, Icon, IconButton, Typography } from "@mui/material";
import MDButton from "components/MDButton";
import MDModal from "components/MDModal";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const SearchCard = ({ title, children, data = {}, setData, list, setList }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleModal = () => setIsOpen(!isOpen);
  const closeSearchModal = () => {
    setData([]);
    setIsOpen(false);
  };

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      setIsOpen(false);
    }
  }, [data]);

  return (
    <>
      <Grid container spacing={2}>
        {Object.keys(data).length == 0 ? (
          <Grid item xs={12}>
            <Link>
              <Typography
                onClick={handleModal}
                variant="h6"
                component="h2"
                sx={{ color: "#000", fontWeight: "bold", marginBottom: 1 }}
              >
                {`Clique aqui para selecionar o ${title}`}
              </Typography>
            </Link>
          </Grid>
        ) : (
          <>
            {list(data)}
            <Grid item xs={2}>
              <IconButton
                sx={{ color: "#000", fontWeight: "bold", marginBottom: 1 }}
                onClick={() => setData({})}
              >
                <Icon>cancel</Icon>
              </IconButton>
            </Grid>
          </>
        )}
      </Grid>
      <MDModal isOpen={isOpen} handleModal={handleModal}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {title}
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          {children}
        </Typography>
        <MDButton variant="gradient" color="info" onClick={closeSearchModal} fullWidth>
          Fechar
        </MDButton>
      </MDModal>
    </>
  );
};

SearchCard.propTypes = {
  data: PropTypes.object,
  setData: PropTypes.func,
  list: PropTypes.element,
  setList: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.element,
  isOpen: PropTypes.boolean,
  setIsOpen: PropTypes.boolean,
  handleModal: PropTypes.func,
};

export default SearchCard;
